import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TradeActionPanel({ symbol, brokerStatus, inWatchlist, onToggleWatchlist, watchlistBusy }) {
  const navigate = useNavigate();

  return (
    <div className="trade-action-panel">
      {brokerStatus?.connected && (
        <span className={`status-pill ${brokerStatus.environment}`}>
          {brokerStatus.environment === 'live' ? 'LIVE MODE' : 'PAPER MODE'}
        </span>
      )}
      <button
        className="primary-button"
        onClick={() => navigate('/', { state: { tradeSymbol: symbol } })}
        disabled={!brokerStatus?.connected}
        title={brokerStatus?.connected ? undefined : 'Connect a broker to trade'}
      >
        Trade {symbol}
      </button>
      <button className="secondary-button" onClick={onToggleWatchlist} disabled={watchlistBusy}>
        {inWatchlist ? 'Remove from Watchlist' : 'Add to Watchlist'}
      </button>
    </div>
  );
}
